import { Auth } from 'aws-amplify'
import awsExport from '../aws-exports.js'

export async function getToken() {
  const auth = await Auth.currentSession()
  return auth.idToken.jwtToken
}

export function getApi(api) {
  for (let item of awsExport.aws_cloud_logic_custom) {
    if (item.name === api) return item
  }
}
